/**
 * @fileoverview Pure validation helpers for the Register multi-step form.
 * @module pages/register/registerValidation
 */
import { validateEmail, validateRFC } from "../../utils/common.js";
import {
  MAX_PASSWORD_LENGTH,
  MIN_PASSWORD_LENGTH,
} from "./registerFormHelpers.js";

export const computePasswordValidation = (password, confirmPassword) => {
  const errors = {
    length:
      password.length < MIN_PASSWORD_LENGTH ||
      password.length > MAX_PASSWORD_LENGTH,
    uppercase: !/[A-Z]/.test(password),
    number: !/\d/.test(password),
    match: password !== confirmPassword || confirmPassword === "",
  };

  return {
    errors,
    isValid: !Object.values(errors).some((hasError) => hasError),
  };
};

export const computeStep1FieldValidation = (values, passwordValidation) => {
  const requiredFields = [
    "firstName",
    "lastName",
    "correoElectronicoPrincipal",
    "codigoPais",
    "telefonoDeOficina",
    "password",
    "confirmPassword",
  ];
  const errors = {};

  requiredFields.forEach((field) => {
    if (!values[field] || values[field].trim() === "") {
      errors[field] = true;
    }
  });

  const email = values.correoElectronicoPrincipal;
  if (email && email.trim() !== "" && !validateEmail(email).isValid) {
    errors.correoElectronicoPrincipal = true;
  }

  if (
    values.password &&
    values.confirmPassword &&
    values.password !== values.confirmPassword &&
    values.password.length > 0 &&
    values.confirmPassword.length > 0
  ) {
    errors.confirmPassword = true;
  }

  if (values.password && !passwordValidation.isValid) {
    errors.password = true;
  }

  return {
    errors,
    isValid: Object.keys(errors).length === 0,
  };
};

export const computeStep2Valid = (values) => {
  const taxId = values.taxId?.trim() ?? "";
  const requiredFields = {
    RFC: values.esExtranjero
      ? true
      : Boolean(values.RFC?.trim()) && validateRFC(values.RFC).isValid,
    razonSocial: values.razonSocial && values.razonSocial.trim() !== "",
    nombreComercial:
      values.nombreComercial && values.nombreComercial.trim() !== "",
    sectorEconomico:
      values.sectorEconomico && values.sectorEconomico !== null,
    taxId: values.esExtranjero
      ? taxId !== "" && !/\s/.test(taxId)
      : true,
  };

  return Object.values(requiredFields).every((field) => field === true);
};

export const computeStep3Valid = (values) => {
  const requiredFields = {
    calle: values.calle && values.calle.trim() !== "",
    pais: values.esExtranjero
      ? true
      : values.pais && values.pais.trim() !== "",
    estado: values.esExtranjero
      ? true
      : values.estado && values.estado.trim() !== "",
    municipio: values.esExtranjero
      ? true
      : values.municipio && values.municipio.trim() !== "",
    colonia: values.esExtranjero
      ? true
      : values.colonia && values.colonia.trim() !== "",
  };

  return Object.values(requiredFields).every((field) => field === true);
};
